import { withTranslate } from "@pathwright/ui/src/components/"
import IconButton from "@pathwright/ui/src/components/button/IconButton"
import View from "@pathwright/ui/src/components/ui/View"
import { Text } from "lib/core/components/text"

const AboutDescription = ({
  id,
  resource_type_display,
  description,
  canEdit,
  t,
  tca,
  i18n
}) => {
  const typeTPath = `resource.types.${resource_type_display.toLowerCase()}`
  const type = i18n.exists(typeTPath) ? tca(typeTPath) : resource_type_display

  const label = t("resource.about.description.label")

  return (
    <View className="AboutDescription" paddingTop paddingBottom>
      <h6>
        <span></span>
        {/* <span>{t("resource.about.description.heading", { label, type })}</span> */}
        {canEdit ? (
          <IconButton
            styleType="secondary"
            icon="edit"
            to={`/manage/resource/${id}/details/`}
          />
        ) : undefined}
      </h6>
      {description ? <Text html={description} /> : undefined}
    </View>
  )
}

export default withTranslate(AboutDescription)
